import './App.css';
import { AuthContextProvider } from './servicos/autorizacao/AuthContex';
import Rotas from './rotas/Rotas';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'react-toastify/dist/ReactToastify.css';

function App() {
  
  return (
    <AuthContextProvider>
        <Rotas />
    </AuthContextProvider>
  );
}

export default App;
